import React , {useEffect, useState} from 'react'
import {  Box, Container, Stack, Tooltip, Typography, Pagination,
    Link, Button, Modal } from '@mui/material'
import CloseButton from '../../../components/CloseButton'
 import * as helpers from '../../../utils/helpers'

const EventDetailsModal = ({event,eventDetailModalOpen, setEventDetailModalOpen}) => {

    const e = event

    
    const price = helpers.formattedShowPriceString(e)
  return (
    <>
           <Modal 
               open={eventDetailModalOpen}
               onClose={()=>setEventDetailModalOpen(!eventDetailModalOpen)}
               >
               <Container sx={{zIndex:999}}>
                   <Box sx={{ 
                       display:'flex',
                       flexDirection:'column',
                       position: 'absolute',
                       top: '50%',
                       left: '50%',
                       transform: 'translate(-50%, -50%)',
                       width: '100%',
                       height:'100%',
                       backgroundColor:  'rgba( 0, 0, 0, 0.1)',
                       backdropFilter:'blur(10px)',
                       borderRadius:'10px',
                       border:'2px solid #000',
                       fontFamily: 'Gilroy, sans-serif',
                       justifyContent:'center',
                       textAlign:'center',
                       alignItems:'center',
                       gap:'0.5rem',
                       padding:'0.5rem',
                       color:'#FFF',
                       
                       }}>
                           <Box sx={{position:'absolute', top:'0.5rem', right:'0.5rem'}}>
                               <CloseButton func={setEventDetailModalOpen} val={eventDetailModalOpen}
                               />
                           </Box>
                            <Box sx={{
                               position:'relative',
                                   display:'flex',flexDirection:'column', 
                                   backgroundImage: 'url("/assets/BodyBG2.png")',
                                   // backgroundImage:'url("/assets/Gradient_01_Frame2.png")',
                                   backgroundAttachment: 'cover',
                                   backgroundRepeat: 'no-repeat',
                                   // background:'#000',
                                   boxShadow:'0 0 10px 5px rgba(0, 255, 0 ,0.5)',
                                   overflow:'hidden',overflowY:'scroll',
                                   width:'80%', maxWidth:'600px',
                                   minWidth:'340px', minHeight:'450px', gap:'0.5rem', color:'#00FF00', borderRadius:'5px'}}>
                               <Box sx={{position:'sticky',top:0, left:0, zIndex:999999999,width:'100%', height:'1.5rem',background:'#F6F6F6'}}>
                            
                                   <Typography sx={{color: '#858585'}} className='blink'>
                                      <b>Event Details</b> 
                                   </Typography>
                                   </Box>
                               
                           <Stack 
                            className='center'
                            sx={{position:'relative',
                               height:'100%',width:'100%',
                               padding:'0.5rem',
                               // flex:1
                                   margin:'auto', 
                                   gap:'0.5rem',
                                   color:'#FFF'
                               }} >
   
                         <h1>{e?.event_name}</h1>
                         {e?.date && <p>{helpers.formatedEventDate(e?.date)}</p>}
                         <h2>@ {e?.location?.venue}</h2>
                         <p>{e?.location?.city}, {e?.location?.state} </p>
                         <p>Doors at: {helpers.convertMilitaryToAmPm(e?.event_time)}</p>
                         {e?.door_age}
                         <span>

                         <b>Cover:</b>
                         {/* {(!e?.price?.adv && !e?.price?.door) && <p>TBA</p>}   */}
                         {/* {price} */}
                         </span>
                         {e?.price?.adv && <p>Advance: {e?.price?.adv.toLowerCase() !=='free'?'$':''}{e?.price?.adv}</p>}
                         {e?.price?.door && <p>Door: {e?.price?.door.toLowerCase() !=='free'?'$':''}{e?.price?.door}</p>}
                         {e?.other_acts?.toLowerCase() !== 'na' &&<>
                         <b>Other Acts:</b>
                         {e?.other_acts}
                         
                         </>}
                         {e?.host && <h4>hosted by: <b>{e?.host}</b></h4>}
                         {e?.details && <div>
                            Details: 
                            <p>
                                {e?.details}
                            </p>
                            </div>}
                         {/* {e?.location?.url &&  */}
                         <Button 
                         sx={{margin:'auto'}}
                         disabled={!e?.location?.url}
                         onClick={((e)=>{
                            e.preventDefault()
                            window.open(e?.location?.url)
                         })}>
                                Visit Venue Listing
                            </Button>
                            {/* } */}
                           </Stack>
                          
                     </Box>
                       </Box>                   
               </Container>
           </Modal>
           
       </>
  )
}

export default EventDetailsModal